<script>
  import Input from "./Input.svelte";

  const pattern = "[^@\\s]+@[^@\\s]+.[^@\\s]+";
</script>

<Input type="email" {pattern} on:focus on:invalid on:click {...$$restProps}>
  <slot />
</Input>
